export const USER_REALM_ROLE = {
	GROUP_ADMIN: 'GROUP_ADMIN',
} as const;
